import { render, staticRenderFns } from "./WrittenManager.vue?vue&type=template&id=ac007e24&"
import script from "./WrittenManager.vue?vue&type=script&lang=ts&"
export * from "./WrittenManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports